import Avatar from 'common/Avatar/Avatar'
import Badge from 'common/Badge/Badge'
import { observer } from 'mobx-react-lite'
import { Key } from 'react'
import { UserRole, Workspace } from 'types'
import { getInitials } from 'utils'
import Styles from './WorkspacesMenu.module.scss'
import { WorkspaceMenuItemActions } from './WorkspaceMenuItemActions'
import cx from 'classnames'
import { useDefaultTheme } from 'hooks/useDefaultTheme'

interface Props {
  isSelected?: boolean
  workspace: Workspace
  onAction?: (key: Key) => void
}

export const WorkspaceMenuItemContent = observer(({ workspace, isSelected = false, onAction }: Props) => {
  const { name, logo_url: logoUrl, is_new: isNew, role, is_virtual_marketer, color_scheme } = workspace
  const defaultTheme = useDefaultTheme()
  const workspaceColorScheme = color_scheme ?? defaultTheme

  const hiddenMenuKeys = new Set<Key>()
  // Allow rename for all workspaces where user is admin, not just the selected one

  return (
    <div className={Styles.workspaceMenuItemContent} data-color-scheme={workspaceColorScheme}>
      <Avatar
        label={getInitials(name)}
        size={20}
        url={logoUrl}
        workspaceId={workspace.id}
        backgroundColor="var(--avatar)"
      />
      <span className={Styles.workspaceMenuItemName}>{name}</span>
      {is_virtual_marketer && <div className={Styles.autopilotPill}>Autopilot</div>}
      <div className={cx(Styles.workspaceMenuItemActions, { [Styles.noAutopilot]: !is_virtual_marketer })}>
        <WorkspaceMenuItemActions workspace={workspace} onAction={onAction} hiddenKeys={hiddenMenuKeys} />
      </div>
      {isNew && <Badge className={cx({ [Styles.badge]: isSelected })}>New</Badge>}
      {role === UserRole.GUEST && <Badge className={cx({ [Styles.badge]: isSelected })}>Guest</Badge>}
    </div>
  )
})
